import React from "react";

import { GetCurrencyCode, capitalizeFirstLetter, currencyFormatter } from "utility";

import { Header, Status } from "Views/Transaction/Details";
import { IBillsTrxnDetails, IDetailWithEnabledFlag } from "Views/Transaction/@types";
import { removeDuplicates, getRecordDetailsDate } from "Views/Transaction/Helper";

import { Details } from "./Details";

export const BillsTrxnDetails = ({
  amount,
  currencyCode,
  requesterName,
  teamName,
  trxnNumber,
  createdDate,
  trxnType,
  notes,
  recipientName,
  status,
  receipts,
  handleSaveRef,
  expenseData,
  closeDetails,
  disableEditing,
  xeroBillBannerData,
  trxnNumberElement,
}: IBillsTrxnDetails) => {
  const date = getRecordDetailsDate(createdDate);

  const details: IDetailWithEnabledFlag[] = [
    {
      id: "requester",
      key: "Requester",
      value: capitalizeFirstLetter(requesterName),
      subtitle: capitalizeFirstLetter(teamName),
      enabled: true,
    },
    { id: "trxn_number", key: "Transaction Number", value: trxnNumberElement(), enabled: true },
    { id: "created_date", key: "Created Date & Time", value: date, enabled: true },
    { id: "trxn_type", key: "Transaction Type", value: trxnType, enabled: true },
    {
      id: "fx_currency_code",
      key: "Foreign Currency Code",
      value: expenseData.foreignCurrencyCode || "N/A",
      enabled: GetCurrencyCode() !== expenseData.foreignCurrencyCode,
    },
    {
      id: "fx_currency_amount",
      key: "Foreign Currency Amount",
      value: currencyFormatter(expenseData.foreignCurrencyAmount, expenseData.foreignCurrencyCode, true),
      enabled: GetCurrencyCode() !== expenseData.foreignCurrencyCode,
    },
  ].filter((detail) => detail.enabled);

  return (
    <>
      <Header
        title={recipientName}
        amount={amount}
        currencyCode={currencyCode}
        xeroBillBannerData={xeroBillBannerData}
      />
      <Status date={date} status={status} />
      <Details
        notes={notes}
        details={details}
        handleSaveRef={handleSaveRef}
        trxnType={trxnType}
        trxnNumber={trxnNumber}
        receipts={removeDuplicates(receipts)}
        categoryId={expenseData.category}
        categoryName={expenseData.categoryName}
        taxName={expenseData.taxName}
        closeDetails={closeDetails}
        tags={expenseData.tags}
        taxId={expenseData.tax}
        disableEditing={disableEditing}
        subscriptionId={expenseData.subscription_id}
        subscriptionInitialProps={{
          vendor_name: recipientName,
          estimated_amount: amount,
          currency: currencyCode,
          budget_id: expenseData.budgetId,
          owner_id: expenseData.payerId,
        }}
      />
    </>
  );
};
